export const buildQueryToGetFilledPatentsByYear = (company: string): any => ({
	q: JSON.stringify({
		_and: [
			{ assignee_id: company },
		],
	}),
	f: JSON.stringify(["year_id", "year_num_patents_for_assignee"]),
});
